import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Month(number) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(1 <= number ? number <= 12 : false)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().a1(toString(message));
  }
  return get_entries().q1(number - 1 | 0);
}
var Month_JANUARY_instance;
var Month_FEBRUARY_instance;
var Month_MARCH_instance;
var Month_APRIL_instance;
var Month_MAY_instance;
var Month_JUNE_instance;
var Month_JULY_instance;
var Month_AUGUST_instance;
var Month_SEPTEMBER_instance;
var Month_OCTOBER_instance;
var Month_NOVEMBER_instance;
var Month_DECEMBER_instance;
function values() {
  return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Month_entriesInitialized;
function Month_initEntries() {
  if (Month_entriesInitialized)
    return Unit_instance;
  Month_entriesInitialized = true;
  Month_JANUARY_instance = Month_0().l27('JANUARY', 0);
  Month_FEBRUARY_instance = Month_0().l27('FEBRUARY', 1);
  Month_MARCH_instance = Month_0().l27('MARCH', 2);
  Month_APRIL_instance = Month_0().l27('APRIL', 3);
  Month_MAY_instance = Month_0().l27('MAY', 4);
  Month_JUNE_instance = Month_0().l27('JUNE', 5);
  Month_JULY_instance = Month_0().l27('JULY', 6);
  Month_AUGUST_instance = Month_0().l27('AUGUST', 7);
  Month_SEPTEMBER_instance = Month_0().l27('SEPTEMBER', 8);
  Month_OCTOBER_instance = Month_0().l27('OCTOBER', 9);
  Month_NOVEMBER_instance = Month_0().l27('NOVEMBER', 10);
  Month_DECEMBER_instance = Month_0().l27('DECEMBER', 11);
}
var $ENTRIES;
var MonthClass;
function Month_0() {
  if (MonthClass === VOID) {
    class $ extends Enum() {
      static l27(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Month');
    MonthClass = $;
  }
  return MonthClass;
}
function toMonth(_this__u8e3s4) {
  return Month(_this__u8e3s4.value());
}
function Month_JANUARY_getInstance() {
  Month_initEntries();
  return Month_JANUARY_instance;
}
function Month_FEBRUARY_getInstance() {
  Month_initEntries();
  return Month_FEBRUARY_instance;
}
function Month_MARCH_getInstance() {
  Month_initEntries();
  return Month_MARCH_instance;
}
function Month_APRIL_getInstance() {
  Month_initEntries();
  return Month_APRIL_instance;
}
function Month_MAY_getInstance() {
  Month_initEntries();
  return Month_MAY_instance;
}
function Month_JUNE_getInstance() {
  Month_initEntries();
  return Month_JUNE_instance;
}
function Month_JULY_getInstance() {
  Month_initEntries();
  return Month_JULY_instance;
}
function Month_AUGUST_getInstance() {
  Month_initEntries();
  return Month_AUGUST_instance;
}
function Month_SEPTEMBER_getInstance() {
  Month_initEntries();
  return Month_SEPTEMBER_instance;
}
function Month_OCTOBER_getInstance() {
  Month_initEntries();
  return Month_OCTOBER_instance;
}
function Month_NOVEMBER_getInstance() {
  Month_initEntries();
  return Month_NOVEMBER_instance;
}
function Month_DECEMBER_getInstance() {
  Month_initEntries();
  return Month_DECEMBER_instance;
}
//region block: exports
export {
  values as values2b27aniquzbrl,
  Month_0 as Monthf07k1mw6tgx4,
  toMonth as toMonth3hgp8a1svgsmg,
};
//endregion

//# sourceMappingURL=Month.mjs.map
